<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useShipStore } from '@/stores/ship'
import MainChart from '@/components/chart/MainChart.vue'
import ShipTab from '@/components/ships/ShipTab.vue'
import { useApplicationStore } from '@/stores/application'
import { useShipTypeStore } from '@/stores/shipType'
import { useFairleadStore } from '@/stores/fairlead'

const shipStore = useShipStore()
const applicationStore = useApplicationStore()
const shipTypeStore = useShipTypeStore()
const fairleadStore = useFairleadStore()
const { items: ships, currentItem: currentShip } = storeToRefs(shipStore)

onMounted(async () => {
	await applicationStore.fetchItems()
	await shipTypeStore.fetchItems()
	await fairleadStore.fetchOptions()
	await shipStore.fetchOptions()
	await shipStore.fetchPaginationItems()
	if (ships.value.length) {
		shipStore.setCurrentItem(ships.value[0])
	}
})
</script>

<template>
	<v-layout class="ship-view">
		<v-row no-gutters class="ship-view__row ma-0">
			<v-col cols="5" class="ship-view__pane">
				<MainChart :ship="currentShip" chart-event="chartEvent" chart-ref="chart"></MainChart>
			</v-col>
			<v-col class="ship-view__pane pa-0 border-left-grey fill-height" cols="7">
				<ShipTab chart-event="chartEvent"></ShipTab>
			</v-col>
		</v-row>
	</v-layout>
</template>

<style scoped>
.ship-view,
.ship-view__row,
.ship-view__pane {
	height: 100%;
	min-height: 0;
}
</style>
